import React from "react";
const Porfolio = (props) => {
  let resumeData = props.resumeData;
  return (
    <section id="portfolio">
      <div className="row">
        <div className="twelve columns collapsed">
          <h1>Check Out Some of My Works.</h1>
          <div
            id="portfolio-wrapper"
            className="bgrid-quarters s-bgrid-thirds cf"
            alt=""
          >
            {resumeData.portfolio &&
              resumeData.portfolio.map((item) => {
                return (
                  <div className="columns portfolio-item">
                    <div className="item-wrap">
                      <a href="#modal-01">
                        <img
                          src={`${item.imgurl}`}
                          className="item-img"
                          alt=""
                        />
                        <div className="overlay">
                          <div className="portfolio-item-meta">
                            <h5>{item.name}</h5>
                            <p>{item.description}</p>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                console.log(item.giturl);
                                window.location.href = item.giturl;
                              }}
                            >
                              <h5>Visit Git</h5>
                            </button>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Porfolio;
